import OpenAI from 'openai'
import {createContext, useContext, useState} from 'react'
import {useDebouncedCallback} from 'use-debounce'

import {CHAT_KEY} from '../Constants'
import {sendMsgToDetectorAI, sendMsgToParaphraseAI} from './AiServiceWorker'
const AIContext = createContext({})

export const OpenAiProvider = ({children}) => {
    // eslint-disable-next-line no-unused-vars
    const [aiResponse, setAiResponse] = useState('')
    const [focusKey, setFocusKey] = useState('')
    const [skeleton, setSkeleton] = useState(false)
    const [paraphrase, setParaphrase] = useState('')
    const [score, setScore] = useState(0)
    const [aiOptions, setAiOptions] = useState('')
    const [openAiWidget, setOpenAiWidget] = useState(false)

    const openai = new OpenAI({
        apiKey: CHAT_KEY,
        dangerouslyAllowBrowser: true,
    })

    const handleSendMsg = async prompt => {
        setAiResponse('')
        setSkeleton(true)

        const responseChunks = await openai.chat.completions.create({
            messages: [{role: 'user', content: prompt}],
            model: 'gpt-3.5-turbo',
            stream: true,
        })

        setSkeleton(false)

        for await (const chunk of responseChunks) {
            if (
                chunk.choices[0].delta.content !== null &&
                chunk.choices[0].delta.content !== undefined
            ) {
                setAiResponse(
                    prevAiResponse =>
                        prevAiResponse + chunk.choices[0].delta.content,
                )
            }
        }
    }

    const handleOnSendAiRequest = useDebouncedCallback(prompt => {
        if (!prompt || prompt === aiResponse) {
            return
        }

        handleSendMsg(aiOptions + prompt)
    }, 0)

    const handleOnFocus = key => {
        if (key !== focusKey) {
            setAiResponse('')
        }
        setFocusKey(key)
    }

    const handleOnDetector = async response => {
        if (!response) {
            return
        }
        const res = await sendMsgToDetectorAI(aiResponse)

        if (res?.score) {
            setScore((100 - res?.score).toFixed())
        }
    }
    const handleOnParaphrase = async () => {
        if (!aiResponse) {
            return
        }
        setSkeleton(true)
        const res = await sendMsgToParaphraseAI(aiResponse)
        if (res) {
            setAiResponse(res)
        }
        setSkeleton(false)
    }
    const handleToggleOpenAiWidget = () => {
        setOpenAiWidget(!openAiWidget)
    }
    return (
        <AIContext.Provider
            value={{
                focusKey: focusKey,
                setFocusKey: setFocusKey,
                aiResponse: aiResponse,
                skeleton: skeleton,
                score: score,
                paraphrase: paraphrase,
                aiOptions: aiOptions,
                openAiWidget: openAiWidget,
                onHideWidget: () => {
                    setOpenAiWidget(false)
                    setAiResponse('')
                },
                toggleOpenAi: handleToggleOpenAiWidget,
                setAiOptions: e => setAiOptions(e),
                handleOnFocus: handleOnFocus,
                onSendAiRequest: handleOnSendAiRequest,
                handleOnDetector: handleOnDetector,
                handleOnParaphrase: handleOnParaphrase,
            }}>
            {children}
        </AIContext.Provider>
    )
}

export const useAIContext = () => useContext(AIContext)
